<form
  class="d-flex flex-column"
  [formGroup]="addGroupForm"
  [ngClass]="{ 'was-validated': isFormSubmitted }"
>
  <div class="d-flex gap-5 my-4">
    <div class="w-25 pt-2">
      <label class="required">{{ 'groupName' | translate }}</label>
    </div>
    <div class="w-50">
      <base-input
        label=""
        formControlName="name"
        [isRequired]="true"
        [isInvalid]="!!addGroupForm.get('name')?.errors"
        [errorMessage]="addGroupForm.get('name')?.errors | baseFieldValidation"
      ></base-input>
    </div>
  </div>

  <div class="d-flex gap-5 my-4">
    <div class="w-25">
      <label>{{ 'permission.plural' | translate }}</label>
    </div>
    <div class="d-flex flex-column w-75">
      <base-permission
        class="pb-3"
        *ngFor="let permission of permissionsToSelect; trackBy: trackByPermissionId"
        [permission]="permission"
        (selectPermission)="onPermissionSelect($event, permission.id)"
      ></base-permission>
    </div>
  </div>

  <div class="p-0 mb-5 mt-3 d-flex justify-content-between">
    <base-button
      [size]="buttonSizes.md"
      color="secondary"
      label="action.cancel"
      (btnClick)="cancelAddingGroup()"
    ></base-button>
    <base-button
      [size]="buttonSizes.md"
      color="primary"
      label="action.save"
      (btnClick)="addGroup()"
    ></base-button>
  </div>
</form>
